import { connect } from "react-redux";

import * as homeActions from "../../../services/home/actions";
import * as applicationActions from "../../applications/actions";

function mapStateToProps(state) {
  return {
    home: state.home,
    financings: state.financing.financings.data,
    payouts: state.financing.financingsIssued.data,
    applications: state.applications.applications.data,
    creditApplications: state.applications.creditApplications.data,
    preApplications: state.applications.preApplications.data,
    reviewingApplications: state.applications.reviewingApplications.data,
    reviewingCreditApplications:
      state.applications.reviewingCreditApplications.data,
    performingCount: state.loans.performingCount,
    restRepayments: state.restRepayments.data,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchNewLoansLoanData: () => {
      dispatch(homeActions.fetch_new_loans_loan_data());
    },
    getCreditApplications: () => {
      dispatch(applicationActions.get_credit_applications(null, null));
    },
  };
}

export const newLoansConnector = connect(mapStateToProps, mapDispatchToProps);
